import { Pencil, Trash2 } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const RowActions = ({ item, index, testId, confirmId, onEdit, onDelete }) => (
  <TableCell className="text-right whitespace-nowrap">
    <button data-testid={`${testId}-edit-${index}`} onClick={() => onEdit(item)} aria-label="Modifier" className="p-2 hover:text-red-600"><Pencil size={15} /></button>
    <button data-testid={`${testId}-delete-${index}`} onClick={() => onDelete(item)} aria-label="Supprimer" className={`p-2 text-xs font-bold ${confirmId === item.id ? "text-white bg-red-600" : "hover:text-red-600"}`}>
      {confirmId === item.id ? "Confirmer ?" : <Trash2 size={15} />}
    </button>
  </TableCell>
);

export const EntityTable = ({ items, columns, testId, confirmId, onEdit, onDelete }) => (
  <div className="bg-white border border-zinc-200 overflow-x-auto">
    <Table>
      <TableHeader>
        <TableRow>
          {columns.map((c) => <TableHead key={c.key} className="text-xs uppercase tracking-wider font-bold">{c.label}</TableHead>)}
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.length === 0 && <TableRow><TableCell colSpan={columns.length + 1} className="text-center text-zinc-500 py-10" data-testid={`${testId}-empty`}>Aucun élément.</TableCell></TableRow>}
        {items.map((it, i) => (
          <TableRow key={it.id} data-testid={`${testId}-row-${i}`}>
            {columns.map((c) => <TableCell key={c.key} className="text-sm">{c.render ? c.render(it) : it[c.key]}</TableCell>)}
            <RowActions item={it} index={i} testId={testId} confirmId={confirmId} onEdit={onEdit} onDelete={onDelete} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
